<!-- ── Hero ── -->
<section class="hero">
  <div class="hero-inner">
    <div class="hero-left">
      <a class="back-link" routerLink="/roles/edit">
        <mat-icon>arrow_back</mat-icon> Back to Manage Users
      </a>
      <h1>Add New User</h1>
      <p class="hero-sub">Create a new user account and assign initial roles</p>
    </div>
  </div>
</section>

<div class="form-shell">

  <!-- Success -->
  <div *ngIf="success" class="status-bar success">
    <mat-icon>check_circle</mat-icon> User created successfully! Redirecting…
  </div>

  <!-- Error -->
  <div *ngIf="error" class="status-bar error">
    <mat-icon>error</mat-icon> {{ error }}
  </div>

  <form *ngIf="!success" (ngSubmit)="createUser()" #userForm="ngForm">

    <!-- Account Information Card -->
    <div class="card">
      <div class="card-header">
        <mat-icon>lock</mat-icon>
        <h3>Account Information</h3>
      </div>
      <div class="card-body">
        <div class="form-grid">
          <div class="field span-full">
            <label for="username">Username *</label>
            <p class="field-hint">The login name for this user</p>
            <div class="input-wrap">
              <mat-icon class="input-icon">person</mat-icon>
              <input type="text" id="username" name="username"
                     [(ngModel)]="newUser.username" required placeholder="Enter username" />
            </div>
          </div>

          <div class="field span-half">
            <label for="password">Password *</label>
            <p class="field-hint">Must be secure and hard to guess</p>
            <div class="input-wrap">
              <mat-icon class="input-icon">key</mat-icon>
              <input type="password" id="password" name="password"
                     [(ngModel)]="newUser.password" required placeholder="Enter password" />
            </div>
          </div>

          <div class="field span-half">
            <label for="confirmPassword">Confirm Password *</label>
            <p class="field-hint">Re-enter the password above</p>
            <div class="input-wrap">
              <mat-icon class="input-icon">key</mat-icon>
              <input type="password" id="confirmPassword" name="confirmPassword"
                     [(ngModel)]="confirmPassword" required placeholder="Confirm password" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Personal Information Card -->
    <div class="card">
      <div class="card-header">
        <mat-icon>badge</mat-icon>
        <h3>Personal Information</h3>
      </div>
      <div class="card-body">
        <div class="form-grid">
          <div class="field span-half">
            <label for="firstname">First Name *</label>
            <div class="input-wrap">
              <mat-icon class="input-icon">person</mat-icon>
              <input type="text" id="firstname" name="firstname"
                     [(ngModel)]="newUser.firstname" placeholder="First name" />
            </div>
          </div>

          <div class="field span-half">
            <label for="lastname">Last Name *</label>
            <div class="input-wrap">
              <mat-icon class="input-icon">person</mat-icon>
              <input type="text" id="lastname" name="lastname"
                     [(ngModel)]="newUser.lastname" required placeholder="Last name" />
            </div>
          </div>

          <div class="field span-half">
            <label for="email">Email</label>
            <div class="input-wrap">
              <mat-icon class="input-icon">email</mat-icon>
              <input type="email" id="email" name="email"
                     [(ngModel)]="newUser.email" placeholder="user@company.com" />
            </div>
          </div>

          <div class="field span-half">
            <label for="phone">Phone Number</label>
            <div class="input-wrap">
              <mat-icon class="input-icon">phone</mat-icon>
              <input type="tel" id="phone" name="phone"
                     [(ngModel)]="newUser.phoneNumber" placeholder="+1 (555) 123-4567" />
            </div>
          </div>

          <div class="field span-full">
            <label for="jobTitle">Job Title</label>
            <div class="input-wrap">
              <mat-icon class="input-icon">work</mat-icon>
              <input type="text" id="jobTitle" name="jobTitle"
                     [(ngModel)]="newUser.job_title" placeholder="e.g. Project Engineer" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Roles Card -->
    <div class="card">
      <div class="card-header">
        <mat-icon>admin_panel_settings</mat-icon>
        <h3>User Roles</h3>
      </div>
      <div class="card-body">
        <p class="roles-hint">Assign roles to determine user permissions</p>
        <div class="role-grid">
          <div *ngFor="let role of availableRoles" class="role-item">
            <label class="role-label">
              <input type="checkbox"
                     [checked]="isRoleSelected(role.id)"
                     (change)="toggleRole(role.id)">
              <div class="role-details">
                <div class="role-name">{{ role.name }}</div>
                <div class="role-description" *ngIf="role.description">{{ role.description }}</div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="status-bar loading">
      <mat-icon>hourglass_empty</mat-icon> Creating user…
    </div>

    <!-- Form Actions -->
    <div class="form-actions">
      <a class="btn-cancel" routerLink="/roles/edit">Cancel</a>
      <button type="submit" class="btn-primary" [disabled]="loading || !userForm.valid">
        <mat-icon *ngIf="!loading">person_add</mat-icon>
        <mat-icon *ngIf="loading" class="spinner">hourglass_empty</mat-icon>
        {{ loading ? 'Creating…' : 'Create User' }}
      </button>
    </div>

  </form>
</div>